<template>
  <div class="animated fadeIn">
    <div v-if="!cseit._id">
      <p>CSE-IT not found, or you do not have access to this CSE-IT in the given Org/Group context.</p>
    </div>
    <div v-if="cseit._id">
      <b-row>
        <b-col sm="9">
          <div>
              <b-tabs class="cseit-tabs" v-model="tabIndex">
                <b-tab title="Introduction">
                  <b-row>
                    <b-col cols="12">
                      <p class="introduction-text"><b>Pre-CSE-IT Assessment</b></p>
                      <p class="introduction-text pt-4 pb-4">Based on your professional judgment and the information available to you at the time of screening, <b>including information not assessed on the screening tool, </b>do you believe the youth is being, or has been, commercially sexually exploited?</p>
                      <h5><b>{{cseit.judge_before}}</b></h5>
                    </b-col>
                  </b-row>
                </b-tab>
                <b-tab title="Questionnaire">
                  <b-row>
                    <b-col cols="12">
                      <div>
                        <b-tabs active-nav-item-class="font-weight-bold text-uppercase ">
                          <b-tab title="HOUSING">
                           <table class="table table-bordered">
                             <thead>
                               <tr>
                                 <th scope="col">1. HOUSING AND CAREGIVING.  The youth experiences housing or caregiving instability for any reason.</th>
                                 <th scope="col" class="text-center" >No Information</th>
                                 <th scope="col" class="text-center" >No Concern</th>
                                 <th scope="col" class="text-center" >Possible Concern</th>
                                 <th scope="col" class="text-center" >Clear Concern</th>
                               </tr>
                             </thead>
                             <tbody>
                               <tr v-for="(question, index) in filterQuestions('1')">
                                <td class="col-sm-6">{{question.order.split('.')[1]}}. {{question.questionText}}</td>
                                <td class="col-sm-2 text-center"><b-form-radio disabled v-model="questionAnswers[question.id]" value="No Information" :name="question.fieldName">0</b-form-radio></td>
                                <td class="col-sm-2 text-center"><b-form-radio disabled v-model="questionAnswers[question.id]" value="No Concern" :name="question.fieldName">0</b-form-radio></td>
                                <td class="col-sm-2 text-center"><b-form-radio disabled v-model="questionAnswers[question.id]" value="Possible Concern" :name="question.fieldName">1</b-form-radio></td>
                                <td class="col-sm-2 text-center"><b-form-radio disabled v-model="questionAnswers[question.id]" value="Clear Concern" :name="question.fieldName">2</b-form-radio></td>
                              </tr>
                             </tbody>
                             <tfoot>
                               <tr>
                                 <td class="col-sm-10"><strong>Indicator 1 Score:</strong>  A subtotal of 4-5 indicates <em>Possible Concern</em>.  A subtotal ≥ 6 indicates <em>Clear Concern</em>.</td>
                                 <td class="col-sm-6"></td>
                                 <td class="col-sm-2 text-center"><span v-if="cseit.calc_q1 === 'No Concern' || cseit.calc_q1 === ''">No Concern</span></td>
                                 <td class="col-sm-2 text-center"><span v-if="cseit.calc_q1 === 'Possible Concern'">Possible Concern</span></td>
                                 <td class="col-sm-2 text-center"><span v-if="cseit.calc_q1 === 'Clear Concern'">Clear Concern</span></td>
                                </tr>
                              </tfoot>
                            </table>
                          </b-tab>
                          <b-tab title="PRIOR ABUSE">
                           <table class="table table-bordered">
                             <thead>
                               <tr>
                                 <th scope="col" class="text-center" >2. PRIOR ABUSE AND TRAUMA. The youth has experienced trauma (not including exploitation).</th>
                                 <th scope="col" class="text-center" >No Information</th>
                                 <th scope="col" class="text-center" >No Concern</th>
                                 <th scope="col" class="text-center" >Possible Concern</th>
                                 <th scope="col" class="text-center" >Clear Concern</th>
                               </tr>
                             </thead>
                             <tbody>
                               <tr v-for="(question, index) in filterQuestions('2')">
                                <td class="col-sm-6">{{question.order.split('.')[1]}}. {{question.questionText}}</td>
                                <td class="col-sm-2 text-center"><b-form-radio disabled v-model="questionAnswers[question.id]" value="No Information" :name="question.fieldName">0</b-form-radio></td>
                                <td class="col-sm-2 text-center"><b-form-radio disabled v-model="questionAnswers[question.id]" value="No Concern" :name="question.fieldName">0</b-form-radio></td>
                                <td class="col-sm-2 text-center"><b-form-radio disabled v-model="questionAnswers[question.id]" value="Possible Concern" :name="question.fieldName">1</b-form-radio></td>
                                <td class="col-sm-2 text-center"><b-form-radio disabled v-model="questionAnswers[question.id]" value="Clear Concern" :name="question.fieldName">2</b-form-radio></td>
                              </tr>
                             </tbody>
                             <tfoot>
                               <tr>
                                 <td class="col-sm-10"><strong>Indicator 2 Score:</strong>  A subtotal of 2 indicates <em>Possible Concern</em>.  A subtotal ≥ 3 indicates <em>Clear Concern</em>.</td>
                                 <td class="col-sm-6"></td>
                                 <td class="col-sm-2 text-center"><span v-if="cseit.calc_q2 === 'No Concern' || cseit.calc_q2 === ''">No Concern</span></td>
                                 <td class="col-sm-2 text-center"><span v-if="cseit.calc_q2 === 'Possible Concern'">Possible Concern</span></td>
                                 <td class="col-sm-2 text-center"><span v-if="cseit.calc_q2 === 'Clear Concern'">Clear Concern</span></td>
                                </tr>
                              </tfoot>
                            </table>
                          </b-tab>
                          <b-tab title="PHYSICAL HEALTH">
                           <table class="table table-bordered">
                             <thead>
                               <tr>
                                 <th scope="col">3. PHYSICAL HEALTH AND APPEARANCE. The youth experiences notable changes in health and appearance.</th>
                                 <th scope="col" class="text-center" >No Information</th>
                                 <th scope="col" class="text-center" >No Concern</th>
                                 <th scope="col" class="text-center" >Possible Concern</th>
                                 <th scope="col" class="text-center" >Clear Concern</th>
                               </tr>
                             </thead>
                             <tbody>
                               <tr v-for="(question, index) in filterQuestions('3')">
                                <td class="col-sm-6">{{question.order.split('.')[1]}}. {{question.questionText}}</td>
                                <td class="col-sm-2 text-center"><b-form-radio disabled v-model="questionAnswers[question.id]" value="No Information" :name="question.fieldName">0</b-form-radio></td>
                                <td class="col-sm-2 text-center"><b-form-radio disabled v-model="questionAnswers[question.id]" value="No Concern" :name="question.fieldName">0</b-form-radio></td>
                                <td class="col-sm-2 text-center"><b-form-radio disabled v-model="questionAnswers[question.id]" value="Possible Concern" :name="question.fieldName">1</b-form-radio></td>
                                <td class="col-sm-2 text-center"><b-form-radio disabled v-model="questionAnswers[question.id]" value="Clear Concern" :name="question.fieldName">2</b-form-radio></td>
                              </tr>
                             </tbody>
                             <tfoot>
                               <tr>
                                 <td class="col-sm-10"><strong>Indicator 3 Score:</strong>  A subtotal of 2-3 indicates <em>Possible Concern</em>.  A subtotal ≥ 4 indicates <em>Clear Concern</em>.</td>
                                 <td class="col-sm-6"></td>
                                 <td class="col-sm-2 text-center"><span v-if="cseit.calc_q3 === 'No Concern' || cseit.calc_q3 === ''">No Concern</span></td>
                                 <td class="col-sm-2 text-center"><span v-if="cseit.calc_q3 === 'Possible Concern'">Possible Concern</span></td>
                                 <td class="col-sm-2 text-center"><span v-if="cseit.calc_q3 === 'Clear Concern'">Clear Concern</span></td>
                                </tr>
                              </tfoot>
                            </table>
                          </b-tab>
                          <b-tab title="ENVIRONMENT">
                           <table class="table table-bordered">
                             <thead>
                               <tr>
                                 <th scope="col">4. ENVIRONMENT AND EXPOSURE. The youth's environment and activities place them at risk for exploitation.</th>
                                 <th scope="col" class="text-center" >No Information</th>
                                 <th scope="col" class="text-center" >No Concern</th>
                                 <th scope="col" class="text-center" >Possible Concern</th>
                                 <th scope="col" class="text-center" >Clear Concern</th>
                               </tr>
                             </thead>
                             <tbody>
                               <tr v-for="(question, index) in filterQuestions('4')">
                                <td class="col-sm-6">{{question.order.split('.')[1]}}. {{question.questionText}}</td>
                                <td class="col-sm-2 text-center"><b-form-radio disabled v-model="questionAnswers[question.id]" value="No Information" :name="question.fieldName">0</b-form-radio></td>
                                <td class="col-sm-2 text-center"><b-form-radio disabled v-model="questionAnswers[question.id]" value="No Concern" :name="question.fieldName">0</b-form-radio></td>
                                <td class="col-sm-2 text-center"><b-form-radio disabled v-model="questionAnswers[question.id]" value="Possible Concern" :name="question.fieldName">1</b-form-radio></td>
                                <td class="col-sm-2 text-center"><b-form-radio disabled v-model="questionAnswers[question.id]" value="Clear Concern" :name="question.fieldName">2</b-form-radio></td>
                              </tr>
                             </tbody>
                             <tfoot>
                               <tr>
                                 <td class="col-sm-10"><strong>Indicator 4 Score:</strong>  A subtotal of 1 indicates <em>Possible Concern</em>.  A subtotal ≥ 2 indicates <em>Clear Concern</em>.</td>
                                 <td class="col-sm-6"></td>
                                 <td class="col-sm-2 text-center"><span v-if="cseit.calc_q4 === 'No Concern' || cseit.calc_q4 === ''">No Concern</span></td>
                                 <td class="col-sm-2 text-center"><span v-if="cseit.calc_q4 === 'Possible Concern'">Possible Concern</span></td>
                                 <td class="col-sm-2 text-center"><span v-if="cseit.calc_q4 === 'Clear Concern'">Clear Concern</span></td>
                                </tr>
                              </tfoot>
                            </table>
                          </b-tab>
                          <b-tab title="RELATIONSHIPS">
                           <table class="table table-bordered">
                             <thead>
                               <tr>
                                 <th scope="col">5. RELATIONSHIPS AND PERSONAL BELONGINGS. The youth's relationships and personal belongings are not consistent with their age or circumstances, suggesting possible recruitment.</th>
                                 <th scope="col" class="text-center" >No Information</th>
                                 <th scope="col" class="text-center" >No Concern</th>
                                 <th scope="col" class="text-center" >Possible Concern</th>
                                 <th scope="col" class="text-center" >Clear Concern</th>
                               </tr>
                             </thead>
                             <tbody>
                               <tr v-for="(question, index) in filterQuestions('5')">
                                <td class="col-sm-6">{{question.order.split('.')[1]}}. {{question.questionText}}</td>
                                <td class="col-sm-2 text-center"><b-form-radio disabled v-model="questionAnswers[question.id]" value="No Information" :name="question.fieldName">0</b-form-radio></td>
                                <td class="col-sm-2 text-center"><b-form-radio disabled v-model="questionAnswers[question.id]" value="No Concern" :name="question.fieldName">0</b-form-radio></td>
                                <td class="col-sm-2 text-center"><b-form-radio disabled v-model="questionAnswers[question.id]" value="Possible Concern" :name="question.fieldName">1</b-form-radio></td>
                                <td class="col-sm-2 text-center"><b-form-radio disabled v-model="questionAnswers[question.id]" value="Clear Concern" :name="question.fieldName">2</b-form-radio></td>
                              </tr>
                             </tbody>
                             <tfoot>
                               <tr>
                                 <td class="col-sm-10"><strong>Indicator 5 Score:</strong>  A subtotal of 1-2 indicates <em>Possible Concern</em>.  A subtotal ≥ 3 indicates <em>Clear Concern</em>.</td>
                                 <td class="col-sm-6"></td>
                                 <td class="col-sm-2 text-center"><span v-if="cseit.calc_q5 === 'No Concern' || cseit.calc_q5 === ''">No Concern</span></td>
                                 <td class="col-sm-2 text-center"><span v-if="cseit.calc_q5 === 'Possible Concern'">Possible Concern</span></td>
                                 <td class="col-sm-2 text-center"><span v-if="cseit.calc_q5 === 'Clear Concern'">Clear Concern</span></td>
                                </tr>
                              </tfoot>
                            </table>
                          </b-tab>
                          <b-tab title="CURRENT TRAUMA">
                           <table class="table table-bordered">
                             <thead>
                               <tr>
                                 <th scope="col">6. SIGNS OF CURRENT TRAUMA. The youth exhibits signs that may result from exposure to any trauma.</th>
                                 <th scope="col" class="text-center" >No Information</th>
                                 <th scope="col" class="text-center" >No Concern</th>
                                 <th scope="col" class="text-center" >Possible Concern</th>
                                 <th scope="col" class="text-center" >Clear Concern</th>
                               </tr>
                             </thead>
                             <tbody>
                               <tr v-for="(question, index) in filterQuestions('6')">
                                <td class="col-sm-6">{{question.order.split('.')[1]}}. {{question.questionText}}</td>
                                <td class="col-sm-2 text-center"><b-form-radio disabled v-model="questionAnswers[question.id]" value="No Information" :name="question.fieldName">0</b-form-radio></td>
                                <td class="col-sm-2 text-center"><b-form-radio disabled v-model="questionAnswers[question.id]" value="No Concern" :name="question.fieldName">0</b-form-radio></td>
                                <td class="col-sm-2 text-center"><b-form-radio disabled v-model="questionAnswers[question.id]" value="Possible Concern" :name="question.fieldName">1</b-form-radio></td>
                                <td class="col-sm-2 text-center"><b-form-radio disabled v-model="questionAnswers[question.id]" value="Clear Concern" :name="question.fieldName">2</b-form-radio></td>
                              </tr>
                             </tbody>
                             <tfoot>
                               <tr>
                                 <td class="col-sm-10"><strong>Indicator 6 Score:</strong>  A subtotal of 1-2 indicates <em>Possible Concern</em>.  A subtotal ≥ 3 indicates <em>Clear Concern</em>.</td>
                                 <td class="col-sm-6"></td>
                                 <td class="col-sm-2 text-center"><span v-if="cseit.calc_q6 === 'No Concern' || cseit.calc_q6 === ''">No Concern</span></td>
                                 <td class="col-sm-2 text-center"><span v-if="cseit.calc_q6 === 'Possible Concern'">Possible Concern</span></td>
                                 <td class="col-sm-2 text-center"><span v-if="cseit.calc_q6 === 'Clear Concern'">Clear Concern</span></td>
                                </tr>
                              </tfoot>
                            </table>
                          </b-tab>
                          <b-tab title="COERCION">
                           <table class="table table-bordered">
                             <thead>
                               <tr>
                                 <th scope="col">7. COERCION. The youth is being controlled or coerced by another person.</th>
                                 <th scope="col" class="text-center" >No Information</th>
                                 <th scope="col" class="text-center" >No Concern</th>
                                 <th scope="col" class="text-center" >Possible Concern</th>
                                 <th scope="col" class="text-center" >Clear Concern</th>
                               </tr>
                             </thead>
                             <tbody>
                               <tr v-for="(question, index) in filterQuestions('7')">
                                <td class="col-sm-6">{{question.order.split('.')[1]}}. {{question.questionText}}</td>
                                <td class="col-sm-2 text-center"><b-form-radio disabled v-model="questionAnswers[question.id]" value="No Information" :name="question.fieldName">0</b-form-radio></td>
                                <td class="col-sm-2 text-center"><b-form-radio disabled v-model="questionAnswers[question.id]" value="No Concern" :name="question.fieldName">0</b-form-radio></td>
                                <td class="col-sm-2 text-center"><b-form-radio disabled v-model="questionAnswers[question.id]" value="Possible Concern" :name="question.fieldName">1</b-form-radio></td>
                                <td class="col-sm-2 text-center"><b-form-radio disabled v-model="questionAnswers[question.id]" value="Clear Concern" :name="question.fieldName">2</b-form-radio></td>
                              </tr>
                             </tbody>
                             <tfoot>
                               <tr>
                                 <td class="col-sm-10"><strong>Indicator 7 Score:</strong>  A subtotal of 1 indicates <em>Possible Concern</em>.  A subtotal ≥ 2 indicates <em>Clear Concern</em>.</td>
                                 <td class="col-sm-6"></td>
                                 <td class="col-sm-2 text-center"><span v-if="cseit.calc_q7 === 'No Concern' || cseit.calc_q7 === ''">No Concern</span></td>
                                 <td class="col-sm-2 text-center"><span v-if="cseit.calc_q7 === 'Possible Concern'">Possible Concern</span></td>
                                 <td class="col-sm-2 text-center"><span v-if="cseit.calc_q7 === 'Clear Concern'">Clear Concern</span></td>
                                </tr>
                              </tfoot>
                            </table>
                          </b-tab>
                          <b-tab title="EXPLOITATION">
                           <table class="table table-bordered">
                             <thead>
                               <tr>
                                 <th scope="col">8. EXPLOITATION.  The youth exchanges sex for money or material goods, including food or shelter.</th>
                                 <th scope="col" class="text-center" >No Information</th>
                                 <th scope="col" class="text-center" >No Concern</th>
                                 <th scope="col" class="text-center" >Possible Concern</th>
                                 <th scope="col" class="text-center" >Clear Concern</th>
                               </tr>
                             </thead>
                             <tbody>
                               <tr v-for="(question, index) in filterQuestions('8')">
                                <td class="col-sm-6">{{question.order.split('.')[1]}}. {{question.questionText}}</td>
                                <td class="col-sm-2 text-center"><b-form-radio disabled v-model="questionAnswers[question.id]" value="No Information" :name="question.fieldName">0</b-form-radio></td>
                                <td class="col-sm-2 text-center"><b-form-radio disabled v-model="questionAnswers[question.id]" value="No Concern" :name="question.fieldName">0</b-form-radio></td>
                                <td class="col-sm-2 text-center"><b-form-radio disabled v-model="questionAnswers[question.id]" value="Possible Concern" :name="question.fieldName">1</b-form-radio></td>
                                <td class="col-sm-2 text-center"><b-form-radio disabled v-model="questionAnswers[question.id]" value="Clear Concern" :name="question.fieldName">2</b-form-radio></td>
                              </tr>
                             </tbody>
                             <tfoot>
                               <tr>
                                 <td class="col-sm-10"><strong>Indicator 8 Score:</strong>  A subtotal of 1 indicates <em>Possible Concern</em>.  A subtotal ≥ 2 indicates <em>Clear Concern</em>.</td>
                                 <td class="col-sm-6"></td>
                                 <td class="col-sm-2 text-center"><span v-if="cseit.calc_q8 === 'No Concern' || cseit.calc_q8 === ''">No Concern</span></td>
                                 <td class="col-sm-2 text-center"><span v-if="cseit.calc_q8 === 'Possible Concern'">Possible Concern</span></td>
                                 <td class="col-sm-2 text-center"><span v-if="cseit.calc_q8 === 'Clear Concern'">Clear Concern</span></td>
                                </tr>
                              </tfoot>
                            </table>
                          </b-tab>
                       </b-tabs>
                      </div>
                    </b-col>
                  </b-row>
                </b-tab>
                <b-tab title="Score">
                  <b-row>
                    <b-col cols="12">
                      <h5>Summary:</h5>
                      <table class="table table-bordered">
                        <thead>
                          <tr>
                            <th scope="col">Indicators</th>
                            <th scope="col">Indicator Score</th>
                            <th scope="col">No Information Summary</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td><strong>1. Housing and Caregiving</strong></td>
                            <td v-bind:class="calculationClass(cseit.calc_q1)">{{cseit.calc_q1}} ({{calculateSummaryNumber(cseit.calc_q1)}})</td>
                            <td>{{questionOneNoInformationPercentage}}%</td>
                          </tr>
                          <tr>
                            <td><strong>2. Prior Abuse or Trauma</strong></td>
                            <td v-bind:class="calculationClass(cseit.calc_q2)">{{cseit.calc_q2}} ({{calculateSummaryNumber(cseit.calc_q2)}})</td>
                            <td>{{questionTwoNoInformationPercentage}}%</td>
                          </tr>
                          <tr>
                            <td><strong>3. Physical Health and Appearance</strong></td>
                            <td v-bind:class="calculationClass(cseit.calc_q3)">{{cseit.calc_q3}} ({{calculateSummaryNumber(cseit.calc_q3)}})</td>
                            <td>{{questionThreeNoInformationPercentage}}%</td>
                          </tr>
                          <tr>
                            <td><strong>4. Environment and Exposure</strong></td>
                            <td v-bind:class="calculationClass(cseit.calc_q4)">{{cseit.calc_q4}} ({{calculateSummaryNumber(cseit.calc_q4)}})</td>
                            <td>{{questionFourNoInformationPercentage}}%</td>
                          </tr>
                          <tr>
                            <td><strong>5. Relationships and Personal Belongings</strong></td>
                            <td v-bind:class="calculationClass(cseit.calc_q5)">{{cseit.calc_q5}} ({{calculateSummaryNumber(cseit.calc_q5)}})</td>
                            <td>{{questionFiveNoInformationPercentage}}%</td>
                          </tr>
                          <tr>
                            <td><strong>6. Signs of Current Trauma</strong></td>
                            <td v-bind:class="calculationClass(cseit.calc_q6)">{{cseit.calc_q6}} ({{calculateSummaryNumber(cseit.calc_q6)}})</td>
                            <td>{{questionSixNoInformationPercentage}}%</td>
                          </tr>
                          <tr>
                            <td><strong>7. Coercion</strong></td>
                            <td v-bind:class="calculationClass(cseit.calc_q7)">{{cseit.calc_q7}} ({{calculateSummaryNumber(cseit.calc_q7)}})</td>
                            <td>{{questionSevenNoInformationPercentage}}%</td>
                          </tr>
                          <tr>
                            <td><strong>8. Exploitation</strong></td>
                            <td v-bind:class="calculationClass(cseit.calc_q8)">{{cseit.calc_q8}} ({{calculateSummaryNumberEight(cseit.calc_q8)}})</td>
                            <td>{{questionEightNoInformationPercentage}}%</td>
                          </tr>
                        </tbody>
                        <tfoot>
                          <tr>
                            <td><strong>Total:</strong></td>
                            <td v-bind:class="calculationClass(cseit.calc_cseitScore)"><strong>{{cseit.calc_cseitScore}} ({{cseitFinalScore}})</strong></td>
                            <td></td>
                          </tr>
                        </tfoot>
                      </table>
                      <p class="introduction-text"><b>CSE-IT Continuum of Concern</b></p>
                      <img src="static/img/cseit_scale.svg" height="75" />
                      <p class="introduction-text"><b>Post-CSE-IT Assessment</b></p>
                      <p class="introduction-text">Based on your professional judgment and the information available to you at the time of this CSE-IT, <i>including information not assessed on the CSE-IT, </i>do you believe the youth is being, or has been, commercially sexually exploited?</p>
                      <h5><b>{{cseit.judge_after}}</b></h5><br/>
                      <h5 v-if="cseit.judge_whynot">{{cseit.judge_whynot}}</h5>
                      <h5 v-if="cseit.can_duration"><b>Duration</b></h5>
                      <h5 v-if="cseit.can_duration">{{capitalize(cseit.can_duration)}}</h5>
                      <h5 v-if="cseit.can_onset"><b>Onset</b></h5>
                      <h5 v-if="cseit.can_onset">{{capitalize(cseit.can_onset)}}</h5>
                      <h5 v-if="cseit.can_perception"><b>Perception</b></h5>
                      <h5 v-if="cseit.can_perception">{{capitalize(cseit.can_perception)}}</h5>
                      <h5 v-if="cseit.comments"><b>Comments</b></h5>
                      <h5 v-if="cseit.comments">{{cseit.comments}}</h5>
                      <h5 class="pt-4"><b>Location: </b>{{cseit_location}}</h5>
                      <h5><b>Program: </b>{{cseit_program}}</h5>

                      <!-- Next Steps (TX and Clear Concern only) -->
                      <div v-if='isUserInTX && cseit.calc_cseitScore === "Clear Concern"'>
                        <h5 class="pt-4"><b>Next Steps</b></h5>
                        <p>Refer the youth for appropriate services, which may include:</p>
                        <ul>
                          <li><b>Care Coordination</b>, and/or</li>
                          <li><b>Commercially Sexually Exploited Youth (CSEY) Advocacy</b></li>
                        </ul>
                        <p>You may visit the <a href='http://gov.texas.gov/cstt' target='_blank'>Office of the Governor Child Sex Trafficking Team website</a> to locate the Care Coordination Team and CSEY Advocate Agency in your county. If you are unsure whether Care Coordination is available in your county, or need assistance identifying the designated CSEY Advocacy provider for your region, please contact the Child Sex Trafficking Team for guidance at: <a href='mailto:cstt@gov.texas.gov'>cstt@gov.texas.gov</a></p>
                      </div>
                    </b-col>
                  </b-row>
                </b-tab>
              </b-tabs>
              <br>
              <router-link class="btn btn-primary" :to="{ path: `/cseit/${cseit.id}/print`, query: { id: cseit._id }}">
                Print
              </router-link>
          </div>
        </b-col>
        <b-col sm="3">
          <!-- Cseit Share Records -->
          <ShareCseitList
            :cseitId="cseit._id"
            :cseitOrganizationOwner="cseit.organizationOwner.id"
            :personId="cseit.person._id"
          ></ShareCseitList>
          <!-- Meta -->
          <b-card no-body :title="cseit.id">
            <b-card-header>
              <b>Meta</b>
            </b-card-header>
            <b-card-body>
              <p class="card-text">
                <small class="text-muted text-uppercase font-weight-bold">CSE-IT ID: </small>
                <small> {{cseit.id}} </small>
              </p>
              <p class="card-text">
                <small class="text-muted text-uppercase font-weight-bold">Person ID</small>
                <br/>
                <small>
                  <router-link :to="'/person/' + cseit.person.id">
                    {{ cseit.person.id }}
                  </router-link>
                </small>
              </p>
            </b-card-body>
            <b-list-group flush>
              <b-list-group-item class="small text-muted">
                <b>Created At: </b> {{ $moment.unix(_.get(cseit, 'createdAt', 1000) / 1000).format("MM/DD/YYYY") }}
                <div v-if="_.isObject(cseit.createdBy)">
                  <b> by: </b> {{ _.get(cseit, 'createdBy.emailAddress', '') }}
                </div>
                <br>
                <b>Last Updated: </b> {{ $moment.unix(_.get(cseit, 'updatedAt', 1000) / 1000).format("MM/DD/YYYY") }}
                <div v-if="_.isObject(cseit.updatedBy)">
                  <b> by: </b> {{ _.get(cseit, 'updatedBy.emailAddress', '') }}
                </div>
              </b-list-group-item>
            </b-list-group>
            <b-card-body flush>
              <p class="card-text">
                <small class="text-muted text-uppercase font-weight-bold">Current Record Owner</small>
                <br/>
                <small class="text-muted"><b> by: </b> {{ _.get(cseit, 'organizationOwner.title') }} </small>
              </p>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import ShareCseitList from '@/components/Cseit/ShareCseitList'
import userStateMixin from '@/mixins/userState.js'

export default {
  name: 'cseit',
  mixins: [userStateMixin],
  components: {
    ShareCseitList
  },
  computed: {
    ...mapGetters({
      user: 'getViewUser',
      cseit: 'getViewCseit',
      cseitQuestions: 'getCseitQuestions',
      initialFields: 'getInitialFields',
      orgPrograms: 'getProgramsByOrg',
      orgLocations: 'getLocationsByOrg'
    })
  },
  data: function () {
    return {
      tabIndex: 0,
      questions: [],
      questionAnswers: [],
      questionOneNoInformationPercentage: 0,
      questionTwoNoInformationPercentage: 0,
      questionThreeNoInformationPercentage: 0,
      questionFourNoInformationPercentage: 0,
      questionFiveNoInformationPercentage: 0,
      questionSixNoInformationPercentage: 0,
      questionSevenNoInformationPercentage: 0,
      questionEightNoInformationPercentage: 0,
      cseitFinalScore: 0,
      locationOptions: [],
      programOptions: [],
      cseit_program: '',
      cseit_location: ''
    }
  },
  watch: {
    orgPrograms: function (newValue) {
      if (newValue) {
        let clonedValue = Object.assign([], newValue)
        clonedValue.sort((a, b) => a.title < b.title ? -1 : a.title > b.title ? 1 : 0)
        this.programOptions = clonedValue.map((program) => {
          var newTitle
          if (program.title === 'Other') {
            newTitle = program.title_otherText
          } else {
            newTitle = program.title
          }
          return {value: program.id, text: newTitle}
        })
        this.getLocationsPrograms()
      }
    },
    orgLocations: function (newValue) {
      if (newValue) {
        let clonedValue = Object.assign([], newValue)
        clonedValue.sort((a, b) => a.title < b.title ? -1 : a.title > b.title ? 1 : 0)
        this.locationOptions = clonedValue.map((location) => {
          return {value: location.id, text: location.title}
        })
        this.getLocationsPrograms()
      }
    },
    authenticatedUserMemberships: function (newValue) {
      this.initializeOwningOrganization(newValue)
    },
    cseitQuestions: function (newValue) {
      if (newValue) {
        this.questions = Object.assign([], newValue)

        this.questions.sort(function (a, b) {
          if (a.order.split('.')[0] > b.order.split('.')[0]) {
            return 1
          } else if (a.order.split('.')[0] < b.order.split('.')[0]) {
            return -1
          } else {
            if (a.order.split('.')[1] > b.order.split('.')[1]) {
              return 1
            } else if (a.order.split('.')[1] < b.order.split('.')[1]) {
              return -1
            } else {
              return 0
            }
          }
        })
      }
    },
    cseit: {
      handler (newValue) {
        if (newValue) {
          if (this.cseit.judge_after) {
            const judgeAfter = this.initialFields.find(i => i.value === this.cseit.judge_after)
            if (judgeAfter && judgeAfter.label) {
              this.cseit.judge_after = judgeAfter.label
            }
          }
          if (this.cseit.judge_before) {
            const judgeBefore = this.initialFields.find(i => i.value === this.cseit.judge_before)
            if (judgeBefore && judgeBefore.label) {
              this.cseit.judge_before = judgeBefore.label
            }
          }
          let i = 0

          let questionOneTotal = 0
          let questionOneNoInformation = 0
          let questionTwoTotal = 0
          let questionTwoNoInformation = 0
          let questionThreeTotal = 0
          let questionThreeNoInformation = 0
          let questionFourTotal = 0
          let questionFourNoInformation = 0
          let questionFiveTotal = 0
          let questionFiveNoInformation = 0
          let questionSixTotal = 0
          let questionSixNoInformation = 0
          let questionSevenTotal = 0
          let questionSevenNoInformation = 0
          let questionEightTotal = 0
          let questionEightNoInformation = 0

          for (let question of this.questions) {
            if (this.questions[i]) {
              let fieldName = question.fieldName
              switch (fieldName) {
                case 'one_a_running':
                  questionOneTotal++
                  this.questionAnswers[question.id] = this.cseit.one_a_running
                  if (this.cseit.one_a_running === 'No Information') { questionOneNoInformation++ }
                  break
                case 'one_b_housing':
                  questionOneTotal++
                  this.questionAnswers[question.id] = this.cseit.one_b_housing
                  if (this.cseit.one_b_housing === 'No Information') { questionOneNoInformation++ }
                  break
                case 'one_c_homeless':
                  questionOneTotal++
                  this.questionAnswers[question.id] = this.cseit.one_c_homeless
                  if (this.cseit.one_c_homeless === 'No Information') { questionOneNoInformation++ }
                  break
                case 'one_d_services':
                  questionOneTotal++
                  this.questionAnswers[question.id] = this.cseit.one_d_services
                  if (this.cseit.one_d_services === 'No Information') { questionOneNoInformation++ }
                  break
                case 'one_e_supervision':
                  questionOneTotal++
                  this.questionAnswers[question.id] = this.cseit.one_e_supervision
                  if (this.cseit.one_e_supervision === 'No Information') { questionOneNoInformation++ }
                  break
                case 'one_f_school':
                  questionOneTotal++
                  this.questionAnswers[question.id] = this.cseit.one_f_school
                  if (this.cseit.one_f_school === 'No Information') { questionOneNoInformation++ }
                  break
                case 'one_g_cps':
                  questionOneTotal++
                  this.questionAnswers[question.id] = this.cseit.one_g_cps
                  if (this.cseit.one_g_cps === 'No Information') { questionOneNoInformation++ }
                  break
                case 'two_a_secabuse':
                  questionTwoTotal++
                  this.questionAnswers[question.id] = this.cseit.two_a_secabuse
                  if (this.cseit.two_a_secabuse === 'No Information') { questionTwoNoInformation++ }
                  break
                case 'two_b_physicalabuse':
                  questionTwoTotal++
                  this.questionAnswers[question.id] = this.cseit.two_b_physicalabuse
                  if (this.cseit.two_b_physicalabuse === 'No Information') { questionTwoNoInformation++ }
                  break
                case 'two_c_emotionalabuse':
                  questionTwoTotal++
                  this.questionAnswers[question.id] = this.cseit.two_c_emotionalabuse
                  if (this.cseit.two_c_emotionalabuse === 'No Information') { questionTwoNoInformation++ }
                  break
                case 'two_d_violence':
                  questionTwoTotal++
                  this.questionAnswers[question.id] = this.cseit.two_d_violence
                  if (this.cseit.two_d_violence === 'No Information') { questionTwoNoInformation++ }
                  break
                case 'three_a_appearance':
                  questionThreeTotal++
                  this.questionAnswers[question.id] = this.cseit.three_a_appearance
                  if (this.cseit.three_a_appearance === 'No Information') { questionThreeNoInformation++ }
                  break
                case 'three_b_phystrauma':
                  questionThreeTotal++
                  this.questionAnswers[question.id] = this.cseit.three_b_phystrauma
                  if (this.cseit.three_b_phystrauma === 'No Information') { questionThreeNoInformation++ }
                  break
                case 'three_c_tattoo':
                  questionThreeTotal++
                  this.questionAnswers[question.id] = this.cseit.three_c_tattoo
                  if (this.cseit.three_c_tattoo === 'No Information') { questionThreeNoInformation++ }
                  break
                case 'three_d_pregsti':
                  questionThreeTotal++
                  this.questionAnswers[question.id] = this.cseit.three_d_pregsti
                  if (this.cseit.three_d_pregsti === 'No Information') { questionThreeNoInformation++ }
                  break
                case 'three_e_sleep':
                  questionThreeTotal++
                  this.questionAnswers[question.id] = this.cseit.three_e_sleep
                  if (this.cseit.three_e_sleep === 'No Information') { questionThreeNoInformation++ }
                  break
                case 'three_f_nutrition':
                  questionThreeTotal++
                  this.questionAnswers[question.id] = this.cseit.three_f_nutrition
                  if (this.cseit.three_f_nutrition === 'No Information') { questionThreeNoInformation++ }
                  break
                case 'three_g_sud':
                  questionThreeTotal++
                  this.questionAnswers[question.id] = this.cseit.three_g_sud
                  if (this.cseit.three_g_sud === 'No Information') { questionThreeNoInformation++ }
                  break
                case 'three_h_increasesud':
                  questionThreeTotal++
                  this.questionAnswers[question.id] = this.cseit.three_h_increasesud
                  if (this.cseit.three_h_increasesud === 'No Information') { questionThreeNoInformation++ }
                  break
                case 'four_a_risksex':
                  questionFourTotal++
                  this.questionAnswers[question.id] = this.cseit.four_a_risksex
                  if (this.cseit.four_a_risksex === 'No Information') { questionFourNoInformation++ }
                  break
                case 'four_b_location':
                  questionFourTotal++
                  this.questionAnswers[question.id] = this.cseit.four_b_location
                  if (this.cseit.four_b_location === 'No Information') { questionFourNoInformation++ }
                  break
                case 'four_c_language':
                  questionFourTotal++
                  this.questionAnswers[question.id] = this.cseit.four_c_language
                  if (this.cseit.four_c_language === 'No Information') { questionFourNoInformation++ }
                  break
                case 'four_d_association':
                  questionFourTotal++
                  this.questionAnswers[question.id] = this.cseit.four_d_association
                  if (this.cseit.four_d_association === 'No Information') { questionFourNoInformation++ }
                  break
                case 'four_e_bullied':
                  questionFourTotal++
                  this.questionAnswers[question.id] = this.cseit.four_e_bullied
                  if (this.cseit.four_e_bullied === 'No Information') { questionFourNoInformation++ }
                  break
                case 'four_f_jj':
                  questionFourTotal++
                  this.questionAnswers[question.id] = this.cseit.four_f_jj
                  if (this.cseit.four_f_jj === 'No Information') { questionFourNoInformation++ }
                  break
                case 'four_g_gang':
                  questionFourTotal++
                  this.questionAnswers[question.id] = this.cseit.four_g_gang
                  if (this.cseit.four_g_gang === 'No Information') { questionFourNoInformation++ }
                  break
                case 'five_a_unhealthyrel':
                  questionFiveTotal++
                  this.questionAnswers[question.id] = this.cseit.five_a_unhealthyrel
                  if (this.cseit.five_a_unhealthyrel === 'No Information') { questionFiveNoInformation++ }
                  break
                case 'five_b_onlinerel':
                  questionFiveTotal++
                  this.questionAnswers[question.id] = this.cseit.five_b_onlinerel
                  if (this.cseit.five_b_onlinerel === 'No Information') { questionFiveNoInformation++ }
                  break
                case 'five_c_photos':
                  questionFiveTotal++
                  this.questionAnswers[question.id] = this.cseit.five_c_photos
                  if (this.cseit.five_c_photos === 'No Information') { questionFiveNoInformation++ }
                  break
                case 'five_d_money':
                  questionFiveTotal++
                  this.questionAnswers[question.id] = this.cseit.five_d_money
                  if (this.cseit.five_d_money === 'No Information') { questionFiveNoInformation++ }
                  break
                case 'five_e_manyphones':
                  questionFiveTotal++
                  this.questionAnswers[question.id] = this.cseit.five_e_manyphones
                  if (this.cseit.five_e_manyphones === 'No Information') { questionFiveNoInformation++ }
                  break
                case 'five_f_travel':
                  questionFiveTotal++
                  this.questionAnswers[question.id] = this.cseit.five_f_travel
                  if (this.cseit.five_f_travel === 'No Information') { questionFiveNoInformation++ }
                  break
                case 'six_a_hypervigilant':
                  questionSixTotal++
                  this.questionAnswers[question.id] = this.cseit.six_a_hypervigilant
                  if (this.cseit.six_a_hypervigilant === 'No Information') { questionSixNoInformation++ }
                  break
                case 'six_b_cues':
                  questionSixTotal++
                  this.questionAnswers[question.id] = this.cseit.six_b_cues
                  if (this.cseit.six_b_cues === 'No Information') { questionSixNoInformation++ }
                  break
                case 'six_c_risktaking':
                  questionSixTotal++
                  this.questionAnswers[question.id] = this.cseit.six_c_risktaking
                  if (this.cseit.six_c_risktaking === 'No Information') { questionSixNoInformation++ }
                  break
                case 'six_d_celldistress':
                  questionSixTotal++
                  this.questionAnswers[question.id] = this.cseit.six_d_celldistress
                  if (this.cseit.six_d_celldistress === 'No Information') { questionSixNoInformation++ }
                  break
                case 'seven_a_abusive':
                  questionSevenTotal++
                  this.questionAnswers[question.id] = this.cseit.seven_a_abusive
                  if (this.cseit.seven_a_abusive === 'No Information') { questionSevenNoInformation++ }
                  break
                case 'seven_b_isolation':
                  questionSevenTotal++
                  this.questionAnswers[question.id] = this.cseit.seven_b_isolation
                  if (this.cseit.seven_b_isolation === 'No Information') { questionSevenNoInformation++ }
                  break
                case 'seven_c_pregnant':
                  questionSevenTotal++
                  this.questionAnswers[question.id] = this.cseit.seven_c_pregnant
                  if (this.cseit.seven_c_pregnant === 'No Information') { questionSevenNoInformation++ }
                  break
                case 'seven_d_coercion':
                  questionSevenTotal++
                  this.questionAnswers[question.id] = this.cseit.seven_d_coercion
                  if (this.cseit.seven_d_coercion === 'No Information') { questionSevenNoInformation++ }
                  break
                case 'seven_e_threats':
                  questionSevenTotal++
                  this.questionAnswers[question.id] = this.cseit.seven_e_threats
                  if (this.cseit.seven_e_threats === 'No Information') { questionSevenNoInformation++ }
                  break
                case 'seven_f_vague':
                  questionSevenTotal++
                  this.questionAnswers[question.id] = this.cseit.seven_f_vague
                  if (this.cseit.seven_f_vague === 'No Information') { questionSevenNoInformation++ }
                  break
                case 'eight_a_exploited':
                  questionEightTotal++
                  this.questionAnswers[question.id] = this.cseit.eight_a_exploited
                  if (this.cseit.eight_a_exploited === 'No Information') { questionEightNoInformation++ }
                  break
                case 'eight_b_filmed':
                  questionEightTotal++
                  this.questionAnswers[question.id] = this.cseit.eight_b_filmed
                  if (this.cseit.eight_b_filmed === 'No Information') { questionEightNoInformation++ }
                  break
                case 'eight_c_history':
                  questionEightTotal++
                  this.questionAnswers[question.id] = this.cseit.eight_c_history
                  if (this.cseit.eight_c_history === 'No Information') { questionEightNoInformation++ }
                  break
                case 'eight_d_quota':
                  questionEightTotal++
                  this.questionAnswers[question.id] = this.cseit.eight_d_quota
                  if (this.cseit.eight_d_quota === 'No Information') { questionEightNoInformation++ }
                  break
              }
            }

            i++
          }

          this.questionOneNoInformationPercentage = parseFloat(parseFloat(parseInt(questionOneNoInformation) / parseInt(questionOneTotal)) * 100).toFixed(2)
          this.questionTwoNoInformationPercentage = parseFloat(parseFloat(parseInt(questionTwoNoInformation) / parseInt(questionTwoTotal)) * 100).toFixed(2)
          this.questionThreeNoInformationPercentage = parseFloat(parseFloat(parseInt(questionThreeNoInformation) / parseInt(questionThreeTotal)) * 100).toFixed(2)
          this.questionFourNoInformationPercentage = parseFloat(parseFloat(parseInt(questionFourNoInformation) / parseInt(questionFourTotal)) * 100).toFixed(2)
          this.questionFiveNoInformationPercentage = parseFloat(parseFloat(parseInt(questionFiveNoInformation) / parseInt(questionFiveTotal)) * 100).toFixed(2)
          this.questionSixNoInformationPercentage = parseFloat(parseFloat(parseInt(questionSixNoInformation) / parseInt(questionSixTotal)) * 100).toFixed(2)
          this.questionSevenNoInformationPercentage = parseFloat(parseFloat(parseInt(questionSevenNoInformation) / parseInt(questionSevenTotal)) * 100).toFixed(2)
          this.questionEightNoInformationPercentage = parseFloat(parseFloat(parseInt(questionEightNoInformation) / parseInt(questionEightTotal)) * 100).toFixed(2)

          let cseitFirstPart = this.calculateSummaryNumber(this.cseit.calc_q1) + this.calculateSummaryNumber(this.cseit.calc_q2) + this.calculateSummaryNumber(this.cseit.calc_q3) + this.calculateSummaryNumber(this.cseit.calc_q4) + this.calculateSummaryNumber(this.cseit.calc_q5) + this.calculateSummaryNumber(this.cseit.calc_q6) + this.calculateSummaryNumber(this.cseit.calc_q7)

          let cseitSecondPart = 0

          if (this.cseit.calc_q8 === 'Possible Concern') {
            cseitSecondPart = 4
          } else if (this.cseit.calc_q8 === 'Clear Concern') {
            cseitSecondPart = 9
          }

          this.cseitFinalScore = cseitFirstPart + cseitSecondPart
        }
      },
      deep: true
    }
  },
  methods: {
    calculationClass: function (name) {
      if (name === 'Clear Concern') {
        return 'text-danger'
      } else if (name === 'Possible Concern') {
        return 'text-warning'
      } else {
        return ''
      }
    },
    capitalize: function (word) {
      return word.replace(/(?:^|\s)\S/g, function (a) { return a.toUpperCase() })
    },
    getLocationsPrograms: function () {
      if (this.locationOptions !== []) {
        let defaultLocationTitle = this.locationOptions.filter((org) => org.value === Number(this.cseit.cseit_location))
        this.cseit_location = defaultLocationTitle[0].text
        let defaultProgramTitle = this.programOptions.filter((org) => org.value === Number(this.cseit.cseit_program))
        this.cseit_program = defaultProgramTitle[0].text
      }
    },
    populateRecords: function () {
      const friendlyCseitId = this.$route.params.id
      const primaryCseitId = this.$route.query.id

      this.$store.dispatch('getCseit', {
        id: friendlyCseitId,
        _id: primaryCseitId
      }).then(response => {
        this.$store.dispatch('getLocationsByOrg', { orgId: this.cseit.organizationCreator.id })
        this.$store.dispatch('getProgramsByOrg', { orgId: this.cseit.organizationCreator.id })
      })
    },
    filterQuestions: function (questionNumber) {
      return this.questions.filter(function (question) {
        return question.order.split('.')[0] === questionNumber
      })
    },
    calculateSummaryNumber: function (text) {
      if (text === 'No Concern') {
        return 0
      } else if (text === 'Possible Concern') {
        return 1
      } else {
        return 2
      }
    },
    calculateSummaryNumberEight: function (text) {
      if (text === 'No Concern') {
        return 0
      } else if (text === 'Possible Concern') {
        return 4
      } else {
        return 9
      }
    }
  },
  mounted () {
    let tab = this.$route.params.tab
    if (tab === 'score') {
      this.tabIndex = 2
    }
  },
  created: function () {
    this.populateRecords()
    this.$store.dispatch('getCseitQuestions')
  }
}
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/views/t1/Admin/Cseit.vue